import { render, staticRenderFns } from "./ShopTournamentScheduleView.vue?vue&type=template&id=37e492af"
import script from "./ShopTournamentScheduleView.vue?vue&type=script&lang=js"
export * from "./ShopTournamentScheduleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports